import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Container, Spinner } from "react-bootstrap";
import { Carousel } from "antd";

export default (props) => {
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();

  const onNextClick = async () => {
    setloading(true);
    navigate("/candidate-dashboard");
  };

  return (
    <div className="common-login role-selection-wrapper">
      <Container className="px-0">
        <div className="row no-gutters">
          <div className="col-lg-6 d-none d-md-block">
            <div className="left-img h-100 bg-primary">
              <div className="login-slider">
                <Carousel autoplay arrows>
                  <div className="slider-content">
                    <img
                      src="/assets/images/slider-img-1.svg"
                      alt="slider-img"
                      className="slider-img"
                    />
                    <h2 className="text-white mb-2">
                      Simplify Your Recruitment Process
                    </h2>
                    <p className="font-weight-medium text-white">
                      Make recruitment easy for businesses of all sizes.
                      Streamline your hiring process, from job posting to
                      candidate management, and discover the best-fit candidates
                      for your team with Jigsaw's innovative platform.
                    </p>
                  </div>
                  <div className="slider-content">
                    <img
                      src="/assets/images/slider-img-2.svg"
                      alt="slider-img"
                      className="slider-img"
                    />
                    <h2 className="text-white mb-2">
                      Rescue Hiring Manger & Candidate From Fate
                    </h2>
                    <p className="font-weight-medium text-white">
                      Don't leave recruitment process of hiring manager and
                      candidate’s career to fate. Take control with Jigsaw's
                      intuitive platform, designed to simplify recruitment and
                      elevate your professional growth. Say goodbye to
                      uncertainty and achieve your goals with Jigsaw.
                    </p>
                  </div>
                  <div className="slider-content">
                    <img
                      src="/assets/images/slider-img-3.svg"
                      alt="slider-img"
                      className="slider-img"
                    />
                    <h2 className="text-white mb-2">
                      Take Control of Your Career with Jigsaw!
                    </h2>
                    <p className="font-weight-medium text-white">
                      Unlock your full potential and achieve your career goals
                      with Jigsaw. Our intuitive platform empowers you with the
                      tools and resources you need to succeed, streamlined job
                      searching and interview preparation. Take control of your
                      future today with Jigsaw.
                    </p>
                  </div>
                </Carousel>
              </div>
            </div>
          </div>
          <div className="col-lg-6 ">
            <div className="form-wrapper py-5 h-100">
              <ul className="steps d-flex align-items-center justify-content-between mx-auto mb-4">
                <li className="step completed">
                  <span>1</span>
                </li>
                <li className="step completed">
                  <span>2</span>
                </li>
                <li className="step completed">
                  <span>3</span>
                </li>
              </ul>

              <div className="successful-message text-center mt-4 mt-lg-5">
                <img
                  src="../assets/images/onboard-successful.png"
                  alt="onboard-successful"
                />
                <h2 className="mt-3">Congratulations, You’re all set!</h2>
                <p className="text-muted">
                  You can always update your profile later
                </p>
              </div>
              <div className="text-center mt-auto py-4">
                <button
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    onNextClick();
                  }}
                >
                  {loading ? (
                    <div className="d-flex justify-content-center align-items-center">
                      <Spinner
                        animation="border"
                        variant=""
                        className="text-white"
                      />
                    </div>
                  ) : (
                    "Let's Start"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
